import { render, staticRenderFns } from "./basicTab-discard.vue?vue&type=template&id=87bd54c2&scoped=true&"
import script from "./basicTab-discard.vue?vue&type=script&lang=js&"
export * from "./basicTab-discard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87bd54c2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('87bd54c2')) {
      api.createRecord('87bd54c2', component.options)
    } else {
      api.reload('87bd54c2', component.options)
    }
    module.hot.accept("./basicTab-discard.vue?vue&type=template&id=87bd54c2&scoped=true&", function () {
      api.rerender('87bd54c2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/Clearing/components/financeManage/basicTab-discard.vue"
export default component.exports